
<script lang="ts">
    export let year: number;
    export let month: string;
    export let day: number;
    export let description: string;
    export let displayCategory: string;
    export let passed: boolean;    
</script>

<div class="flex gap-4 items-center">
    <div class="border-solid border-[1px] border-gray-300 text-center w-[70px] pb-1">
        <div class="text-xs border-solid border-b-[1px] border-gray-300 uppercase">{month}</div>
        <div class="text-md font-bold">{day}</div>
        <div class="text-xs">{year}</div>
    </div>
    <div class="capitalize">
        {description} 
        <div class="text-sm">{displayCategory}</div>
        {#if passed}
        <div class="text-xs text-orange-700">(Passed)</div>
        {/if}
    </div>
</div>